class CustomSlider {
  constructor(element) {
    this.element = element;
    this.slider = null;
    this.config = this.getConfigFromAttributes();
    this.init();
    this.setupMutationObserver();
  }

  getConfigFromAttributes() {
    const config = {
      type: this.element.dataset.type || 'slide',
      perPage: parseInt(this.element.dataset.perPage) || 1,
      perMove: parseInt(this.element.dataset.perMove) || 1,
      gap: parseInt(this.element.dataset.gap) || 10,
      padding: parseInt(this.element.dataset.padding) || 0,
      height: parseInt(this.element.dataset.height) || 500,
      width: this.element.dataset.width || '100%',
      focus: this.element.dataset.focus || 'center',
      autoplay: this.element.dataset.autoplay === 'true',
      interval: parseInt(this.element.dataset.interval) || 3000,
      pauseOnHover: this.element.dataset.pauseOnHover === 'true',
      pauseOnFocus: this.element.dataset.pauseOnFocus === 'true',
      rewind: this.element.dataset.rewind === 'true',
      speed: parseInt(this.element.dataset.speed) || 1000,
      waitForTransition: this.element.dataset.waitForTransition === 'true',
      arrowPath: "M1.07754 36.7134L17.3257 20.045L1.07754 3.37659C0.472589 2.75722 0.472589 1.76819 1.07754 1.14883C1.36295 0.857515 1.75366 0.693359 2.16146 0.693359C2.56929 0.693359 2.95991 0.857515 3.24537 1.14883L20.534 18.8811C21.1652 19.5287 21.1652 20.5613 20.534 21.2089L3.24867 38.9412C2.96301 39.2345 2.57095 39.4 2.16146 39.4C1.75202 39.4 1.35985 39.2345 1.07421 38.9412C0.469213 38.3218 0.469213 37.3327 1.07421 36.7134H1.07754Z",
      arrows: this.element.dataset.arrows === 'true',
      pagination: this.element.dataset.pagination === 'true',
      drag: this.element.dataset.drag === 'true',
      snap: this.element.dataset.snap === 'true',
      flickPower: parseInt(this.element.dataset.flickPower) || 1,
      flickMaxPages: parseInt(this.element.dataset.flickMaxPages) || 1,
      direction: this.element.dataset.direction || 'ltr',
      trimSpace: this.element.dataset.trimSpace === 'true',
      updateOnMove: this.element.dataset.updateOnMove === 'true',
      throttle: parseInt(this.element.dataset.throttle) || 100,
      keyboard: this.element.dataset.keyboard === 'true',
      wheel: this.element.dataset.wheel === 'true',
      releaseWheel: this.element.dataset.releaseWheel === 'true',
      isNavigation: this.element.dataset.isNavigation === 'true',
      enableSlideEffects: this.element.dataset.enableSlideEffects === 'true',
      breakpoints: {
        640: {
          perPage: parseInt(this.element.dataset.mobilePerPage) || 1,
          gap: parseInt(this.element.dataset.mobileGap) || 5,
          height: parseInt(this.element.dataset.mobileHeight) || 300
        }
      }
    };
    // console.log('arrows', this.element.dataset);
    // console.log('config', config);
    return config;
  }

  init() {
    this.slider = new Splide(this.element, this.config);
    this.slider.mount();
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
            console.log('mutation', mutation);
          this.updateConfig();
        }
      });
    });

    observer.observe(this.element, {
      attributes: true,
      attributeFilter: ['data-type', 'data-per-page', 'data-per-move', 'data-gap', 'data-padding', 
        'data-height', 'data-width', 'data-focus', 'data-autoplay', 'data-interval', 'data-pause-on-hover',
        'data-pause-on-focus', 'data-rewind', 'data-speed', 'data-wait-for-transition', 'data-arrows',
        'data-pagination', 'data-drag', 'data-snap', 'data-flick-power', 'data-flick-max-pages',
        'data-direction', 'data-trim-space', 'data-update-on-move', 'data-throttle', 'data-keyboard',
        'data-wheel', 'data-release-wheel', 'data-is-navigation', 'data-mobile-per-page',
        'data-mobile-gap', 'data-mobile-height', 'data-enable-slide-effects']
    });
  }

  updateConfig() {
    const newConfig = this.getConfigFromAttributes();
    this.slider.options = newConfig;
    this.slider.refresh();
  }
}

// Initialize sliders after Splide library is loaded
function initializeSliders() {
  if (typeof Splide !== 'undefined') {
    const sliders = document.querySelectorAll('.splide');
    sliders.forEach(slider => new CustomSlider(slider));
  } else {
    // If Splide is not loaded yet, wait and try again
    setTimeout(initializeSliders, 100);
  }
}

// Start initialization when DOM is ready
document.addEventListener('DOMContentLoaded', initializeSliders);
